import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import '../../styles/game/GameLimits.css';
import '../../styles/game/howToPlay.css';
import '../../styles/game/FreeBets.css';


function FreeBets({ isOpen, onClose, FreeBetsOpen }) {
    const [isVisible, setIsVisible] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => setIsVisible(true), 10);
        } else {
            setIsVisible(false);
        }
    }, [isOpen]);

    useEffect(() => {
        if(isLoader) {
            // console.log(isLoader)
        }
        if (!isLoader) {
            // console.log(isLoader)
        }
    }, [isLoader]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    const [freeBetContent, setFreeBetContent] = useState(false)
    function freeBetsContent() {
            return (
            <>
                <div className={'freeBetsItem'}>
                    <div className={'freeBetsItem-row'}>
                                        <span className={'client-seed-radio active'}>
                                            <div className={'radio-dot'}></div>
                                        </span>
                        <div className={'freeBetsItem-row-text'}>{t("playWithCash")}</div>
                    </div>
                    <div className={'free-bets-header'}>
                        <div>{t("activeFreeBets")}</div>
                        <div className={'archive-btn'} onClick={() => {
                            setFreeBetContent(true)
                            setIsLoader(true)
                            setTimeout(() => {
                                setIsLoader(false)
                            }, 350)
                        }}>
                            <div className={'free-bets-history-icon'}></div>
                            <div>{t("archive")}</div>
                        </div>
                    </div>
                    <div className={'free-bets-active'}>
                        <div className={'free-bet-image'}></div>
                        <div className={'free-bets-none'}>
                            {t("noActive")}
                        </div>
                    </div>
                </div>
            </>
            )
    }

    function archiveContent() {
        return (
            <>
                <div className={'free-bets-header-archive'}>
                    <div>
                        {t("archive")}
                    </div>
                    <div className={'archive-back-btn'} onClick={() => setFreeBetContent(false)}>
                        <div className={'archive-back-btn-icon'}></div>
                        <div className={'font-size-12'}>{t("back")}</div>
                    </div>
                </div>
                <div className={'free-bets-active'}>
                    <div className={`archive-loader-wrap ${isLoader ? "show" : ""}`}>
                        <span className={'archive-loader'}></span>
                    </div>
                    <div className={'free-bet-image'}></div>
                    <div className={'free-bets-none'}>
                        {t("nothingYet")}
                    </div>
                </div>
            </>
        )
    }


    return (
        <>
            <div className={`modalWrapper ${isVisible ? "show" : "fade-out"}`}
                 onClick={() => {
                     setTimeout(() => setIsVisible(false), 10);
                     onClose();
                 }}>
            </div>
            <div className={`gameRulesModal ${isVisible ? "show" : "fade-out"}`} onClick={() => {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }}>
                <div className={`gameLimitsWrapper ${isVisible ? "show" : "fade"}`}>
                    <div className={'gameRulesContent'} onClick={(e) => e.stopPropagation()}>
                        <div className={'gameRulesHeader'}>
                            <span>{t("freeBetsTitle")}</span>
                            <button className={'gameRulesCloseBtn'} onClick={() => {
                                setTimeout(() => setIsVisible(false), 10);
                                onClose();
                            }}>
                                <span>×</span>
                            </button>
                        </div>
                        <div className={'freeBetsBody'}>
                            <div className={'freeBetsContent'}>
                                {freeBetContent ? archiveContent() : freeBetsContent()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FreeBets;